import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next'
import { t } from 'i18next'
import { useLazyQuery } from '@apollo/client';
import { GET_CAPTAIN_SHIFT_SCHEDULE_STATUS, GET_BOAT_ROUTE_ASSIGNMENT_STATUS } from 'graphql/route/queries';

export function CommonStatusDropdown({ statusFor, fields, purpose }) {

  console.log('fields= value===', fields.value)
  const [statusList, setStatusList] = useState(null)


  const [getCaptainShiftScheduleStatus, { loading: captainShiftLoading, error: captainShiftError }] = useLazyQuery(GET_CAPTAIN_SHIFT_SCHEDULE_STATUS, {
    notifyOnNetworkStatusChange: true,
    onCompleted: data => {
      if (data.captainShiftScheduleStatus.length > 0) {
        setStatusList(data.captainShiftScheduleStatus)
      }
    },
  })

  const [getBoatRouteAssignmentStatus, { loading: boatRouteLoading, error: boatRouteError }] = useLazyQuery(GET_BOAT_ROUTE_ASSIGNMENT_STATUS, {
    notifyOnNetworkStatusChange: true,
    onCompleted: data => {
      if (data.boatRouteAssignmentStatus.length > 0) {
        setStatusList(data.boatRouteAssignmentStatus)
      }
    },
  })


  // get Type List
  const getCaptainShiftStatus = () => {
    if (statusFor === 'CaptainShiftScheduleStatus') {
      getCaptainShiftScheduleStatus({
        variables: {
          "code": null
        },
      })
    }
    if (statusFor === 'BoatRouteAssignmentStatus') {
      getBoatRouteAssignmentStatus({
        variables: {
          "code": null
        },
      })
    }
  }
  useEffect(() => {
    console.log('useEffect=====', statusFor)
    getCaptainShiftStatus();
  }, []);

  return (
    <>

      {boatRouteLoading && captainShiftLoading && <div className="flex justify-center items-center bg-white py-5">Loading ....</div>}
      {captainShiftError && (
        <select>
          <option value={null}>{t('No data found')}</option>
        </select>
      )}
      {(!boatRouteLoading || !captainShiftLoading) && !captainShiftError && statusList?.length === 0 && (
        <select>
          <option value={null}>{t('No data found')}</option>
        </select>
      )}
      {statusList?.length > 0 && (
        <select
          {...fields}
          className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-primary sm:max-w-xs sm:text-sm sm:leading-6"
        >

          {purpose === 'filter' ? <option value={null}> {t('All')} </option> : <option value="" disabled> {t('Select Here')} </option>}
          {statusList.map((status) => (
            <option key={status.code} value={status.code}>
              {status.description.en}
            </option>
          ))}
        </select>
      )}
    </>
  );
}

